export default __webpack_public_path__ + "static/media/MintReveal.loading.98ff2f6e.svg";